// TermsConditions.jsx
import React from "react";
import "./privacy-policy.css"; // reuse the same styles as the Privacy Policy page
import Navbar from "./Navbar";

const TermsConditions = () => {
  return (
    <>
      <Navbar />
      <main className="policy">
        <div className="policy__inner">
          <header className="policy__header">
            <h1 className="policy__title">Terms and Conditions</h1>
            <p className="policy__updated">
              Last Updated: <strong>1st of September 2025</strong>
            </p>
          </header>

          <p className="policy__lead">
            Welcome to <span className="accent">FlxDeck</span>. By accessing or using our website and services, you agree to the following Terms and Conditions. Please read them carefully.
          </p>

          <section className="policy__section">
            <h2>1. Acceptance of Terms</h2>
            <p>By using our website or submitting the partnership form, you confirm that you are authorized to represent your gym or business and that you agree to these Terms and Conditions.</p>
          </section>

          <section className="policy__section">
            <h2>2. Use of Services</h2>
            <p>FlxDeck provides information about our kiosk solution for gyms. You may not misuse our website or services, including attempting to disrupt or interfere with our systems.</p>
          </section>

          <section className="policy__section">
            <h2>3. Partnership Requests</h2>
            <p>
              When you submit a form to become a partner, you agree to provide accurate and complete information. Our team will review your request and contact you to discuss next steps. We reserve
              the right to decline partnership requests at our discretion.
            </p>
          </section>

          <section className="policy__section">
            <h2>4. Intellectual Property</h2>
            <p>
              All content on this website, including text, images, logos, and software, is the property of FlxDeck and may not be copied, modified, or distributed without our prior written consent.
            </p>
          </section>

          <section className="policy__section">
            <h2>5. Limitation of Liability</h2>
            <p>FlxDeck is not liable for any indirect, incidental, or consequential damages that may arise from the use or inability to use our website or services.</p>
          </section>

          <section className="policy__section">
            <h2>6. Privacy Policy</h2>
            <p>
              Your privacy matters to us. FlxDeck does not collect personal data from your gym members through the kiosk. Members never need to log in, sign up, or download anything. Please refer to
              our <a href="/privacy">Privacy Policy</a> for more details on how we handle partner information.
            </p>
          </section>

          <section className="policy__section">
            <h2>7. Changes to Terms</h2>
            <p>We may update these Terms and Conditions from time to time. Any changes will be posted on this page with an updated “Last Updated” date.</p>
          </section>

          <section className="policy__section">
            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:contact@flxdeck.com">contact@flxdeck.com</a>.
            </p>
          </section>
        </div>
      </main>
    </>
  );
};

export default TermsConditions;
